




































































































































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { quanxianMixin } from "@/mixins/quanxianMixin";
import {
  GetShitiList,
  DeleteShiti,
} from "@/request/storehouse";
import {
  GetShitiManageList,
  Getchecker,
  GetYuyiOptions,
} from "@/request/check";
import MainHeader from "@/components/main-header/main-header.vue";
import ShitiHengji from "../../components/hengji/shiti-hengji.vue";
import EditShiti from "@/components/edit-shiti.vue";
@Component({
  components: {
    MainHeader,
    ShitiHengji,
    EditShiti,
  },
})
export default class Name extends mixins(listMixin, quanxianMixin) {
  private data: any[] = [];
  private ifShowHengji: any = false;
  private hengjiId: any = "";
  private ifShowEdit: any = false;
  private types: any = [];
  private status: any = ["标准实体", "增补-未审核", "增补-已通过", "增补-未通过"];
  private jiaoyanyuan: any = [];
  private suodingData: any = [];

  /**
   * @description 查看
   */
   private goRead(item: any) {
    this.$store.commit("updateIfCompose", false);
    this.$router.push({
      path: "/main/mark/biaozhu/detail",
      query: {
        id: item._id,
        kind: "实体校验",
        type: "read",
      },
    });
  }

  private addSure(val: any) {
    this.ifShowEdit = false;
    this.getList();
    this.$message.success("新增成功");
  }

  private cancelHengji() {
    this.ifShowHengji = false;
  }

  private addOne() {
    this.ifShowEdit = true;
  }

  /**
   * @description 跳转用户编辑
   */
  private jumpCompose(item: any) {
    if (item["锁定"]) {
      return;
    }
    this.$store.commit("updateIfCompose", false);
    this.$router.push({
      path: "/main/check/bentijiaoyan/compose",
      query: {
        id: item.id,
        kind: item["语义类型"],
      },
    });
  }

  private deleteOne(item: any) {
    if (item["锁定"]) {
      return;
    }
    this.$confirm(
      "删除后该实体及下属的子内容将全部删除，您确定需要删除么？",
      "删除",
      {
        customClass: "commonConfirm",
      }
    )
      .then(() => {
        DeleteShiti(this, item.id).then((res: any) => {
          this.$message.success("删除成功");
          this.getList();
        });
      })
      .catch(() => {
        console.log("取消");
      });
  }

  private openHengji(item: any) {
    this.hengjiId = item.id;
    this.ifShowHengji = true;
  }

  private getSuoding() {
    GetShitiManageList(this).then((data: any) => {
      this.suodingData = data;
    });
  }

  private getChecker() {
    const params: any = {
      params: {
        kind: "原文校验",
      },
    };
    Getchecker(this, params).then((res: any) => {
      this.jiaoyanyuan = res;
    });
  }

  private remoteMethod(e: any) {
    const params: any = {
      params: {
        search: e,
        is_all: true,
      },
    };
    GetYuyiOptions(this, params).then((res: any) => {
      this.types = res;
    });
  }

  /**
   * @description
   */
  getList() {
    const params: any = {
      params: {
        search: this.filters.search,
        is_temp: this.filters.status,
        table_name: this.filters.type["名称"],
        user_id: this.filters["校验员"].id,
        order_field: this.filters.sort_field,
        order_value: this.filters.sort_value,
        current_page: this.filters.current_page,
        page_num: this.filters.page_count,
      },
    };
    localStorage.setItem("bentijiaoyanliFilter", JSON.stringify(this.filters));
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetShitiList(this, params, loading)
      .then((data: any) => {
        loading.close();
        this.data = data.data;
        this.filters.total_count = data.total_count;
        this.filters.total_page = data.total_page;
        if (this.data.length === 0) {
          this.ifShowEmpty = true;
        } else {
          this.ifShowEmpty = false;
        }
      })
      .catch(() => {
        loading.close();
      });
  }

  /**
   * @description 初始化
   */
  mounted() {
    this.filters.type = {};
    this.filters.status = "";
    this.filters.sort_field = "更新时间";
    this.filters["校验员"] = {};
    const d = localStorage.getItem("bentijiaoyanliFilter") || "";
    if (d) {
      this.filters = JSON.parse(d);
    }
    this.remoteMethod("");
    this.getList();
    this.getSuoding();
    this.getChecker();
  }
}
